import React, { useContext, type FC } from "react";

import clsx from "clsx";
import { type StepWizardChildProps } from "react-step-wizard";
import { StringParam, useQueryParams, withDefault } from "use-query-params";

import { PrimaryButton } from "@shared/buttons";

import { SideNavContext } from "..";
import { Steps } from "../steps";

import { StepContainer } from "./step-container";

export const IntroductoryVideo: FC<Partial<StepWizardChildProps>> = ({
  nextStep,
}) => {
  const context = React.useContext(SideNavContext);
  const { setSubNavItems } = useContext(SideNavContext);

  if (context.subNavItems.length > 0) {
    setSubNavItems([]);
  }
  const [_, setSearchParams] = useQueryParams({
    subStep: withDefault(StringParam, ""),
    step: withDefault(StringParam, ""),
    provider: withDefault(StringParam, ""),
  });
  return (
    <StepContainer
      hideFooter
      isLast={false}
      knowledgeBaseLink=""
      knowledgeBaseText=""
    >
      <div className=" h-full overflow-hidden">
        <div
          className={clsx(
            "bg-interstellar flex-col rounded-lg mx-6 mt-6  h-[calc(100%-56px)] overflow-hidden pt-12 pb-8 px-16 text-white",
            "flex items-center justify-start gap-8 bg-right-bottom bg-no-repeat",
          )}
        >
          <div className="flex flex-col">
            <div className="max-w-[800px] text-center">
              <h1 className="text-[42px] leading-[56px] mb-7 mt-2">
                Welcome to Northbeam!
              </h1>
              <p className="text-2xl font-normal leading-8 max-w-[600px]">
                Before you begin setup, please make sure you have spoken to our{" "}
                <a
                  href="https://www.northbeam.io/demo"
                  target="_blank"
                  rel="noreferrer"
                  className=" no-underline text-primary"
                >
                  Account Team
                </a>
                . An active service agreement is required to proceed.
              </p>
            </div>
            <div
              className={clsx(
                "flex flex-col  gap-8 max-w-[600px] mt-8 mx-auto",
              )}
            >
              <PrimaryButton
                onClick={() => {
                  setSearchParams({
                    step: Steps.ACCOUNT_MANAGERS,
                  });
                  nextStep && nextStep();
                }}
                className="w-[404px] h-16 px-10 py-6 bg-cosmic rounded-[32px] flex-col justify-center items-center gap-2 inline-flex"
              >
                <div className="w-[253px] justify-center items-center gap-6 inline-flex">
                  <div className="flex-col justify-center items-center gap-2 inline-flex">
                    <div className="h-3 justify-center items-center gap-2 inline-flex">
                      <div className="text-white text-lg font-semibold uppercase leading-tight tracking-tight">
                        Begin Setup
                      </div>
                    </div>
                  </div>
                  <i className="fa-sharp fa-regular fa-arrow-right fa-xl"></i>
                </div>
              </PrimaryButton>
            </div>
          </div>
          <div>
            <Clip url="https://storage.googleapis.com/files.northbeam.io/img/231220_1701_northbeam_orb_v1.3%20(stretching%20and%20jumpiness%20fixed).webm" />
          </div>
        </div>
      </div>
    </StepContainer>
  );
};

function Clip({ url }: { url: string }) {
  return (
    <video src={url} autoPlay loop muted>
      Sorry, your browser does not support embedded videos.
    </video>
  );
}
